import React, { useEffect, useMemo, useState } from 'react';
import { API_BASE } from '../config/api';

const GestionComponentes = () => {
  const [componentes, setComponentes] = useState([]);
  const [colegios, setColegios] = useState([]);
  const [depositos, setDepositos] = useState([]);
  const [stockDepositos, setStockDepositos] = useState([]);
  const [tecnicosDepositos, setTecnicosDepositos] = useState([]);
  const [filtroArea, setFiltroArea] = useState('todos');
  const [busqueda, setBusqueda] = useState('');
  const [pestanaActiva, setPestanaActiva] = useState('stock');
  const [movimientos, setMovimientos] = useState([]);
  const [repuestosUsados, setRepuestosUsados] = useState([]);
  const [cargandoInforme, setCargandoInforme] = useState(false);
  const [filtrosInforme, setFiltrosInforme] = useState({
    fecha_desde: '',
    fecha_hasta: '',
    colegio_id: '',
    componente_id: '',
    deposito_id: '',
    tipo_movimiento: ''
  });

  const [nuevoComponente, setNuevoComponente] = useState({
    codigo_unico: '',
    nombre: '',
    descripcion: '',
    cantidad: 0,
    deposito_id: 1,
    area_destinada: 'informática'
  });

  const [nuevoDeposito, setNuevoDeposito] = useState({ nombre: '', alias: '' });
  const [depositoEditandoId, setDepositoEditandoId] = useState(null);

  const [modoEdicion, setModoEdicion] = useState(false);
  const [componenteSeleccionado, setComponenteSeleccionado] = useState(null);
  const [modalTransferencia, setModalTransferencia] = useState({
    abierto: false,
    componente: null,
    deposito_origen_id: '',
    deposito_destino_id: '',
    cantidad: '',
    motivo: '',
    enviando: false,
  });

  useEffect(() => {
    fetchComponentes();
    fetchColegios();
    fetchDepositos();
    fetchStockDepositos();
    fetchTecnicosDepositos();
  }, []);

  useEffect(() => {
    if (pestanaActiva === 'usados') cargarRepuestosUsados();
    if (pestanaActiva === 'movimientos') cargarMovimientos();
    if (pestanaActiva === 'depositos') {
      fetchDepositos();
      fetchStockDepositos();
      fetchTecnicosDepositos();
    }
  }, [pestanaActiva]);

  const fetchComponentes = async () => {
    try {
      const res = await fetch(`${API_BASE}/api/componentes`);
      if (!res.ok) throw new Error('No se pudo cargar componentes');
      const data = await res.json();
      setComponentes(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error('Error al cargar componentes:', e);
      setComponentes([]);
    }
  };

  const fetchColegios = async () => {
    try {
      const res = await fetch(`${API_BASE}/api/colegios`);
      if (!res.ok) throw new Error('No se pudo cargar colegios');
      const data = await res.json();
      setColegios(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error('Error al cargar colegios:', e);
      setColegios([]);
    }
  };

  const fetchDepositos = async () => {
    try {
      const res = await fetch(`${API_BASE}/api/depositos`);
      if (!res.ok) throw new Error('No se pudo cargar depositos');
      const data = await res.json();
      setDepositos(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error('Error al cargar depositos:', e);
      setDepositos([]);
    }
  };

  const fetchStockDepositos = async () => {
    try {
      const res = await fetch(`${API_BASE}/api/inventario/stock-depositos`);
      if (!res.ok) throw new Error('No se pudo cargar stock por deposito');
      const data = await res.json();
      setStockDepositos(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error('Error al cargar stock por deposito:', e);
      setStockDepositos([]);
    }
  };

  const fetchTecnicosDepositos = async () => {
    try {
      const res = await fetch(`${API_BASE}/api/tecnicos-depositos`);
      if (!res.ok) throw new Error('No se pudo cargar tecnicos/depositos');
      const data = await res.json();
      setTecnicosDepositos(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error('Error al cargar tecnicos/depositos:', e);
      setTecnicosDepositos([]);
    }
  };

  const manejarCambio = (e) => {
    const { name, value } = e.target;
    setNuevoComponente({ ...nuevoComponente, [name]: value });
  };

  const registrarOActualizarComponente = async (e) => {
    e.preventDefault();

    const url = modoEdicion
      ? `${API_BASE}/api/componentes/${componenteSeleccionado}`
      : `${API_BASE}/api/componentes`;

    const metodo = modoEdicion ? 'PUT' : 'POST';

    try {
      const res = await fetch(url, {
        method: metodo,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(nuevoComponente)
      });

      if (res.ok) {
        alert(modoEdicion ? 'Componente actualizado correctamente' : 'Componente registrado correctamente');

        setNuevoComponente({
          codigo_unico: '',
          nombre: '',
          descripcion: '',
          cantidad: 0,
          deposito_id: depositos[0]?.id || 1,
          area_destinada: 'informática'
        });

        setModoEdicion(false);
        setComponenteSeleccionado(null);
        fetchComponentes();
      } else {
        let msg = 'Error al guardar el componente';
        try {
          const data = await res.json();
          if (data?.mensaje) msg = data.mensaje;
        } catch {}
        alert(msg);
      }
    } catch (e) {
      console.error('Error guardando componente:', e);
      alert('Error de conexión al guardar el componente');
    }
  };

  const editarComponente = (comp) => {
    setNuevoComponente({ ...comp });
    setModoEdicion(true);
    setComponenteSeleccionado(comp.id);
  };

  const cancelarEdicion = () => {
    setModoEdicion(false);
    setComponenteSeleccionado(null);
    setNuevoComponente({
      codigo_unico: '',
      nombre: '',
      descripcion: '',
      cantidad: 0,
      deposito_id: depositos[0]?.id || 1,
      area_destinada: 'informática'
    });
  };

  const eliminarComponente = async (id) => {
    if (!window.confirm('¿Seguro que deseas eliminar este componente?')) return;

    try {
      const res = await fetch(`${API_BASE}/api/componentes/${id}`, {
        method: 'DELETE'
      });

      if (res.ok) {
        alert('Componente eliminado');
        fetchComponentes();
      } else {
        let msg = 'Error al eliminar componente';
        try {
          const data = await res.json();
          if (data?.mensaje) msg = data.mensaje;
        } catch {}
        alert(msg);
      }
    } catch (e) {
      console.error('Error eliminando componente:', e);
      alert('Error de conexión al eliminar componente');
    }
  };

  const filtrarComponentes = () => {
    const texto = busqueda.toLowerCase();

    return (componentes || [])
      .filter((c) => filtroArea === 'todos' || c.area_destinada === filtroArea)
      .filter((c) => {
        const nombre = (c.nombre || '').toLowerCase();
        const codigo = (c.codigo_unico || '').toLowerCase();
        return nombre.includes(texto) || codigo.includes(texto);
      });
  };

  const paramsInforme = (soloUsados = false) => {
    const params = new URLSearchParams();
    if (filtrosInforme.fecha_desde) params.append('fecha_desde', filtrosInforme.fecha_desde);
    if (filtrosInforme.fecha_hasta) params.append('fecha_hasta', filtrosInforme.fecha_hasta);
    if (filtrosInforme.colegio_id) params.append('colegio_id', filtrosInforme.colegio_id);
    if (filtrosInforme.componente_id) params.append('componente_id', filtrosInforme.componente_id);
    if (filtrosInforme.deposito_id) params.append('deposito_id', filtrosInforme.deposito_id);
    if (!soloUsados && filtrosInforme.tipo_movimiento) {
      params.append('tipo_movimiento', filtrosInforme.tipo_movimiento);
    }
    return params.toString();
  };

  const cargarRepuestosUsados = async () => {
    setCargandoInforme(true);
    try {
      const res = await fetch(`${API_BASE}/api/inventario/repuestos-utilizados?${paramsInforme(true)}`);
      const data = await res.json();
      setRepuestosUsados(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error('Error cargando repuestos utilizados:', e);
      setRepuestosUsados([]);
    } finally {
      setCargandoInforme(false);
    }
  };

  const cargarMovimientos = async () => {
    setCargandoInforme(true);
    try {
      const res = await fetch(`${API_BASE}/api/inventario/movimientos?${paramsInforme(false)}`);
      const data = await res.json();
      setMovimientos(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error('Error cargando movimientos:', e);
      setMovimientos([]);
    } finally {
      setCargandoInforme(false);
    }
  };

  const cambiarFiltroInforme = (e) => {
    const { name, value } = e.target;
    setFiltrosInforme((prev) => ({ ...prev, [name]: value }));
  };

  const aplicarFiltrosInforme = () => {
    if (pestanaActiva === 'usados') cargarRepuestosUsados();
    if (pestanaActiva === 'movimientos') cargarMovimientos();
  };

  const exportarMovimientosPDF = () => {
    const params = paramsInforme(false);
    const query = params ? `?${params}` : '';
    window.open(`${API_BASE}/api/exportar-movimientos-stock-pdf${query}`, '_blank');
  };

  const elegirDeposito = (titulo) => {
    if (!depositos.length) return '';
    const listado = depositos.map((d) => `${d.id}: ${d.nombre}${d.alias ? ` (${d.alias})` : ''}`).join('\n');
    return window.prompt(`${titulo}\n\n${listado}\n\nEscribí el ID del depósito:`);
  };

  const registrarEntradaStock = async (comp) => {
    const cantidadRaw = window.prompt(`Cantidad a ingresar para ${comp.nombre}:`);
    if (cantidadRaw === null) return;

    const cantidad = Number(cantidadRaw);
    if (!Number.isFinite(cantidad) || cantidad <= 0) {
      alert('Cantidad inválida');
      return;
    }

    const depositoRaw = elegirDeposito('Depósito destino para la entrada');
    if (depositoRaw === null) return;
    const deposito_id = Number(depositoRaw);
    if (!depositos.some((d) => Number(d.id) === deposito_id)) {
      alert('Depósito inválido');
      return;
    }

    const motivo = window.prompt('Motivo de la entrada (opcional):') || 'Entrada de stock';

    try {
      const res = await fetch(`${API_BASE}/api/componentes/${comp.id}/entrada-stock`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Actor-Rol': localStorage.getItem('rolAdmin') || '',
          'X-Actor-Id': localStorage.getItem('adminId') || '',
        },
        body: JSON.stringify({ cantidad, motivo, deposito_id }),
      });

      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        alert(data?.mensaje || 'No se pudo registrar la entrada');
        return;
      }

      alert(data?.mensaje || 'Entrada registrada');
      fetchComponentes();
      fetchDepositos();
      fetchStockDepositos();
      if (pestanaActiva === 'movimientos') cargarMovimientos();
    } catch (e) {
      console.error('Error registrando entrada:', e);
      alert('Error de conexión al registrar entrada');
    }
  };

  const abrirModalTransferencia = (comp) => {
    setModalTransferencia({
      abierto: true,
      componente: comp,
      deposito_origen_id: '',
      deposito_destino_id: '',
      cantidad: '',
      motivo: 'Transferencia entre depósitos',
      enviando: false,
    });
  };

  const cerrarModalTransferencia = () => {
    setModalTransferencia({
      abierto: false,
      componente: null,
      deposito_origen_id: '',
      deposito_destino_id: '',
      cantidad: '',
      motivo: '',
      enviando: false,
    });
  };

  const cambiarTransferencia = (e) => {
    const { name, value } = e.target;
    setModalTransferencia((prev) => ({ ...prev, [name]: value }));
  };

  const transferirStock = async (e) => {
    e.preventDefault();

    const comp = modalTransferencia.componente;
    if (!comp) return;

    const deposito_origen_id = Number(modalTransferencia.deposito_origen_id);
    const deposito_destino_id = Number(modalTransferencia.deposito_destino_id);
    const cantidad = Number(modalTransferencia.cantidad);

    if (!depositos.some((d) => Number(d.id) === deposito_origen_id) ||
        !depositos.some((d) => Number(d.id) === deposito_destino_id) ||
        deposito_origen_id === deposito_destino_id) {
      alert('Depósitos inválidos');
      return;
    }
    if (!Number.isFinite(cantidad) || cantidad <= 0) {
      alert('Cantidad inválida');
      return;
    }

    const motivo = modalTransferencia.motivo || 'Transferencia entre depósitos';

    try {
      setModalTransferencia((prev) => ({ ...prev, enviando: true }));
      const res = await fetch(`${API_BASE}/api/componentes/${comp.id}/transferir-stock`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Actor-Rol': localStorage.getItem('rolAdmin') || '',
          'X-Actor-Id': localStorage.getItem('adminId') || '',
        },
        body: JSON.stringify({ deposito_origen_id, deposito_destino_id, cantidad, motivo }),
      });

      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        alert(data?.mensaje || 'No se pudo transferir stock');
        setModalTransferencia((prev) => ({ ...prev, enviando: false }));
        return;
      }

      alert(data?.mensaje || 'Stock transferido');
      fetchComponentes();
      fetchDepositos();
      fetchStockDepositos();
      if (pestanaActiva === 'movimientos') cargarMovimientos();
      cerrarModalTransferencia();
    } catch (e) {
      console.error('Error transfiriendo stock:', e);
      alert('Error de conexión al transferir stock');
      setModalTransferencia((prev) => ({ ...prev, enviando: false }));
    }
  };

  const guardarDeposito = async (e) => {
    e.preventDefault();
    if (!nuevoDeposito.nombre.trim()) {
      alert('Ingresá el nombre del depósito');
      return;
    }

    const url = depositoEditandoId
      ? `${API_BASE}/api/depositos/${depositoEditandoId}`
      : `${API_BASE}/api/depositos`;
    const method = depositoEditandoId ? 'PUT' : 'POST';

    try {
      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...nuevoDeposito, activo: 1 }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        alert(data?.mensaje || 'No se pudo guardar el depósito');
        return;
      }
      setNuevoDeposito({ nombre: '', alias: '' });
      setDepositoEditandoId(null);
      fetchDepositos();
    } catch (e) {
      console.error('Error guardando depósito:', e);
      alert('Error de conexión al guardar depósito');
    }
  };

  const editarDeposito = (deposito) => {
    setDepositoEditandoId(deposito.id);
    setNuevoDeposito({ nombre: deposito.nombre || '', alias: deposito.alias || '' });
  };

  const eliminarDeposito = async (deposito) => {
    if (!window.confirm(`¿Desactivar ${deposito.nombre}?`)) return;
    try {
      const res = await fetch(`${API_BASE}/api/depositos/${deposito.id}`, { method: 'DELETE' });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        alert(data?.mensaje || 'No se pudo desactivar el depósito');
        return;
      }
      fetchDepositos();
      fetchTecnicosDepositos();
    } catch (e) {
      console.error('Error desactivando depósito:', e);
      alert('Error de conexión al desactivar depósito');
    }
  };

  const asignarDepositoTecnico = async (usuarioId, depositoId) => {
    try {
      const res = await fetch(`${API_BASE}/api/tecnicos/${usuarioId}/deposito`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ deposito_id: depositoId || null }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        alert(data?.mensaje || 'No se pudo asignar depósito');
        return;
      }
      fetchTecnicosDepositos();
    } catch (e) {
      console.error('Error asignando depósito:', e);
      alert('Error de conexión al asignar depósito');
    }
  };

  const depositosAsignadosUsuario = (usuario) =>
    String(usuario.deposito_ids || '')
      .split(',')
      .map((id) => Number(id))
      .filter(Boolean);

  const alternarDepositoUsuario = async (usuario, depositoId) => {
    const actuales = depositosAsignadosUsuario(usuario);
    const id = Number(depositoId);
    const siguientes = actuales.includes(id)
      ? actuales.filter((item) => item !== id)
      : [...actuales, id];

    try {
      const res = await fetch(`${API_BASE}/api/tecnicos/${usuario.tecnico_id}/deposito`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ deposito_ids: siguientes }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        alert(data?.mensaje || 'No se pudo asignar depósitos');
        return;
      }
      fetchTecnicosDepositos();
    } catch (e) {
      console.error('Error asignando depósitos:', e);
      alert('Error de conexión al asignar depósitos');
    }
  };

  const formatearFecha = (fecha) => (fecha ? new Date(fecha).toLocaleString() : '-');

  const FiltrosInforme = ({ incluirTipo = false }) => (
    <div className="bg-white p-4 rounded shadow mb-4 grid md:grid-cols-5 gap-3">
      <input
        type="date"
        name="fecha_desde"
        value={filtrosInforme.fecha_desde}
        onChange={cambiarFiltroInforme}
        className="border px-3 py-2 rounded"
      />
      <input
        type="date"
        name="fecha_hasta"
        value={filtrosInforme.fecha_hasta}
        onChange={cambiarFiltroInforme}
        className="border px-3 py-2 rounded"
      />
      <select
        name="colegio_id"
        value={filtrosInforme.colegio_id}
        onChange={cambiarFiltroInforme}
        className="border px-3 py-2 rounded"
      >
        <option value="">Todos los colegios</option>
        {colegios.map((colegio) => (
          <option key={colegio.id} value={colegio.id}>
            {colegio.nombre}
          </option>
        ))}
      </select>
      <select
        name="componente_id"
        value={filtrosInforme.componente_id}
        onChange={cambiarFiltroInforme}
        className="border px-3 py-2 rounded"
      >
        <option value="">Todos los componentes</option>
        {componentes.map((comp) => (
          <option key={comp.id} value={comp.id}>
            {comp.nombre}
          </option>
        ))}
      </select>
      <select
        name="deposito_id"
        value={filtrosInforme.deposito_id}
        onChange={cambiarFiltroInforme}
        className="border px-3 py-2 rounded"
      >
        <option value="">Todos los depósitos</option>
        {depositos.map((deposito) => (
          <option key={deposito.id} value={deposito.id}>
            {deposito.nombre}
          </option>
        ))}
      </select>
      {incluirTipo ? (
        <select
          name="tipo_movimiento"
          value={filtrosInforme.tipo_movimiento}
          onChange={cambiarFiltroInforme}
          className="border px-3 py-2 rounded"
        >
          <option value="">Todos los tipos</option>
          <option value="entrada">Entrada</option>
          <option value="salida">Salida</option>
          <option value="ajuste">Ajuste</option>
        </select>
      ) : (
        <button
          type="button"
          onClick={aplicarFiltrosInforme}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Filtrar
        </button>
      )}
      {incluirTipo && (
        <button
          type="button"
          onClick={aplicarFiltrosInforme}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 md:col-span-5"
        >
          Filtrar movimientos
        </button>
      )}
    </div>
  );

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4 text-blue-700">
        {modoEdicion ? 'Editar Componente' : 'Inventario de Componentes'}
      </h2>

      <div className="mb-5 flex flex-wrap gap-2">
        <button
          type="button"
          onClick={() => setPestanaActiva('stock')}
          className={`px-4 py-2 rounded border ${pestanaActiva === 'stock' ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-gray-700'}`}
        >
          Stock actual
        </button>
        <button
          type="button"
          onClick={() => setPestanaActiva('usados')}
          className={`px-4 py-2 rounded border ${pestanaActiva === 'usados' ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-gray-700'}`}
        >
          Repuestos utilizados
        </button>
        <button
          type="button"
          onClick={() => setPestanaActiva('movimientos')}
          className={`px-4 py-2 rounded border ${pestanaActiva === 'movimientos' ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-gray-700'}`}
        >
          Movimientos
        </button>
        <button
          type="button"
          onClick={() => setPestanaActiva('depositos')}
          className={`px-4 py-2 rounded border ${pestanaActiva === 'depositos' ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-gray-700'}`}
        >
          Depósitos
        </button>
      </div>

      {pestanaActiva === 'stock' && (
        <>
      <form onSubmit={registrarOActualizarComponente} className="bg-white p-6 shadow rounded-lg space-y-4 max-w-xl mb-6">
        <input
          className="w-full border px-3 py-2 rounded"
          type="text"
          name="codigo_unico"
          placeholder="Código único"
          value={nuevoComponente.codigo_unico}
          onChange={manejarCambio}
          required
        />
        <input
          className="w-full border px-3 py-2 rounded"
          type="text"
          name="nombre"
          placeholder="Nombre del componente"
          value={nuevoComponente.nombre}
          onChange={manejarCambio}
          required
        />
        <textarea
          className="w-full border px-3 py-2 rounded"
          name="descripcion"
          placeholder="Descripción"
          value={nuevoComponente.descripcion}
          onChange={manejarCambio}
        />
        <input
          className="w-full border px-3 py-2 rounded"
          type="number"
          name="cantidad"
          placeholder="Cantidad"
          value={nuevoComponente.cantidad}
          onChange={manejarCambio}
          required
          disabled={modoEdicion}
        />

        {!modoEdicion && (
          <select
            className="w-full border px-3 py-2 rounded"
            name="deposito_id"
            value={nuevoComponente.deposito_id}
            onChange={manejarCambio}
            required
          >
            {depositos.map((deposito) => (
              <option key={deposito.id} value={deposito.id}>
                Stock inicial en: {deposito.nombre}
              </option>
            ))}
          </select>
        )}

        {modoEdicion && (
          <p className="text-xs text-gray-500">
            La cantidad total se administra desde entradas, transferencias y salidas de depósitos.
          </p>
        )}

        <select
          className="w-full border px-3 py-2 rounded"
          name="area_destinada"
          value={nuevoComponente.area_destinada}
          onChange={manejarCambio}
          required
        >
          <option value="informática">Informática</option>
          <option value="robótica">Robótica</option>
          <option value="ambas">Ambas</option>
        </select>

        <div className="flex gap-3">
          <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition">
            {modoEdicion ? 'Actualizar' : 'Registrar'}
          </button>
          {modoEdicion && (
            <button type="button" onClick={cancelarEdicion} className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500 transition">
              Cancelar
            </button>
          )}
        </div>
      </form>

      {/* Botones de filtro */}
      <div className="mb-4 flex flex-wrap gap-2">
        <button onClick={() => setFiltroArea('todos')} className={`px-3 py-1 rounded ${filtroArea === 'todos' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`}>Todos</button>
        <button onClick={() => setFiltroArea('informática')} className={`px-3 py-1 rounded ${filtroArea === 'informática' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`}>Informática</button>
        <button onClick={() => setFiltroArea('robótica')} className={`px-3 py-1 rounded ${filtroArea === 'robótica' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`}>Robótica</button>
        <button onClick={() => setFiltroArea('ambas')} className={`px-3 py-1 rounded ${filtroArea === 'ambas' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`}>Ambas</button>
      </div>

      {/* Buscador */}
      <input
        type="text"
        placeholder="Buscar por nombre o código"
        className="w-full mb-4 border px-3 py-2 rounded"
        value={busqueda}
        onChange={(e) => setBusqueda(e.target.value)}
      />

      <h3 className="text-xl font-semibold mb-2">Componentes registrados</h3>
      <ul className="space-y-2">
        {filtrarComponentes().map((comp) => (
          <li key={comp.id} className="bg-white p-4 rounded shadow flex items-center justify-between">
            <div>
              <p className="font-semibold">
                {comp.nombre} <span className="text-sm text-gray-500">({comp.codigo_unico})</span>
              </p>
              <p className="text-sm text-gray-600">{comp.descripcion}</p>
              <p className="text-sm">
                Stock total: {comp.cantidad} – Área:{' '}
                <span className="italic text-blue-600">{comp.area_destinada}</span>
              </p>
            </div>
            <div className="space-x-2">
              <button onClick={() => editarComponente(comp)} className="bg-yellow-500 text-white px-3 py-1 rounded hover:bg-yellow-600 transition">✏️</button>
              <button onClick={() => registrarEntradaStock(comp)} className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 transition">Entrada</button>
              <button onClick={() => abrirModalTransferencia(comp)} className="bg-indigo-600 text-white px-3 py-1 rounded hover:bg-indigo-700 transition">Mover</button>
              <button onClick={() => eliminarComponente(comp.id)} className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700 transition">🗑️</button>
            </div>
          </li>
        ))}
      </ul>
        </>
      )}

      {pestanaActiva === 'usados' && (
        <div>
          <FiltrosInforme />

          <div className="bg-white rounded shadow overflow-x-auto">
            <table className="min-w-full">
              <thead>
                <tr className="bg-blue-100 text-left">
                  <th className="px-3 py-2">Fecha</th>
                  <th className="px-3 py-2">Colegio</th>
                  <th className="px-3 py-2">Sala</th>
                  <th className="px-3 py-2">Equipo</th>
                  <th className="px-3 py-2">Pedido</th>
                      <th className="px-3 py-2">Componente</th>
                      <th className="px-3 py-2">Cantidad</th>
                      <th className="px-3 py-2">Depósito</th>
                      <th className="px-3 py-2">Técnico</th>
                      <th className="px-3 py-2">Admin</th>
                </tr>
              </thead>
              <tbody>
                {cargandoInforme ? (
                  <tr><td colSpan="10" className="text-center py-6 text-gray-500">Cargando...</td></tr>
                ) : repuestosUsados.length === 0 ? (
                  <tr><td colSpan="10" className="text-center py-6 text-gray-500">No hay repuestos utilizados con esos filtros.</td></tr>
                ) : (
                  repuestosUsados.map((mov) => (
                    <tr key={mov.id} className="border-t">
                      <td className="px-3 py-2">{formatearFecha(mov.fecha)}</td>
                      <td className="px-3 py-2">{mov.colegio || '-'}</td>
                      <td className="px-3 py-2">{mov.sala || '-'}</td>
                      <td className="px-3 py-2">{mov.equipo || '-'}</td>
                      <td className="px-3 py-2">{mov.pedido_id || '-'}</td>
                      <td className="px-3 py-2">
                        <div className="font-semibold">{mov.componente_nombre}</div>
                        <div className="text-xs text-gray-500">{mov.codigo_unico}</div>
                      </td>
                      <td className="px-3 py-2">{mov.cantidad}</td>
                      <td className="px-3 py-2">{mov.deposito_origen || mov.deposito_destino || '-'}</td>
                      <td className="px-3 py-2">{mov.tecnico_usuario || '-'}</td>
                      <td className="px-3 py-2">{mov.admin_usuario || '-'}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {pestanaActiva === 'movimientos' && (
        <div>
          <FiltrosInforme incluirTipo />

          <div className="mb-4 flex justify-end">
            <button
              type="button"
              onClick={exportarMovimientosPDF}
              className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 transition"
            >
              Generar PDF
            </button>
          </div>

          <div className="bg-white rounded shadow overflow-x-auto">
            <table className="min-w-full">
              <thead>
                <tr className="bg-blue-100 text-left">
                  <th className="px-3 py-2">Fecha</th>
                  <th className="px-3 py-2">Tipo</th>
                  <th className="px-3 py-2">Componente</th>
                  <th className="px-3 py-2">Cantidad</th>
                  <th className="px-3 py-2">Depósito origen</th>
                  <th className="px-3 py-2">Depósito destino</th>
                  <th className="px-3 py-2">Colegio</th>
                  <th className="px-3 py-2">Pedido</th>
                  <th className="px-3 py-2">Usuario</th>
                  <th className="px-3 py-2">Motivo</th>
                </tr>
              </thead>
              <tbody>
                {cargandoInforme ? (
                  <tr><td colSpan="10" className="text-center py-6 text-gray-500">Cargando...</td></tr>
                ) : movimientos.length === 0 ? (
                  <tr><td colSpan="10" className="text-center py-6 text-gray-500">No hay movimientos con esos filtros.</td></tr>
                ) : (
                  movimientos.map((mov) => (
                    <tr key={mov.id} className="border-t">
                      <td className="px-3 py-2">{formatearFecha(mov.fecha)}</td>
                      <td className="px-3 py-2 capitalize">{mov.tipo_movimiento}</td>
                      <td className="px-3 py-2">
                        <div className="font-semibold">{mov.componente_nombre}</div>
                        <div className="text-xs text-gray-500">{mov.codigo_unico}</div>
                      </td>
                      <td className="px-3 py-2">{mov.cantidad}</td>
                      <td className="px-3 py-2">{mov.deposito_origen || '-'}</td>
                      <td className="px-3 py-2">{mov.deposito_destino || '-'}</td>
                      <td className="px-3 py-2">{mov.colegio || '-'}</td>
                      <td className="px-3 py-2">{mov.pedido_id || '-'}</td>
                      <td className="px-3 py-2">{mov.tecnico_usuario || mov.admin_usuario || '-'}</td>
                      <td className="px-3 py-2">{mov.motivo || '-'}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {pestanaActiva === 'depositos' && (
        <div className="space-y-6">
          <form onSubmit={guardarDeposito} className="bg-white p-4 rounded shadow grid md:grid-cols-3 gap-3">
            <input
              className="border px-3 py-2 rounded"
              placeholder="Nombre del depósito"
              value={nuevoDeposito.nombre}
              onChange={(e) => setNuevoDeposito((prev) => ({ ...prev, nombre: e.target.value }))}
              required
            />
            <input
              className="border px-3 py-2 rounded"
              placeholder="Alias o referencia"
              value={nuevoDeposito.alias}
              onChange={(e) => setNuevoDeposito((prev) => ({ ...prev, alias: e.target.value }))}
            />
            <div className="flex gap-2">
              <button className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700" type="submit">
                {depositoEditandoId ? 'Actualizar depósito' : 'Crear depósito'}
              </button>
              {depositoEditandoId && (
                <button
                  className="border px-4 py-2 rounded hover:bg-gray-50"
                  type="button"
                  onClick={() => {
                    setDepositoEditandoId(null);
                    setNuevoDeposito({ nombre: '', alias: '' });
                  }}
                >
                  Cancelar
                </button>
              )}
            </div>
          </form>

          <div className="grid lg:grid-cols-2 gap-6">
            <div className="bg-white rounded shadow overflow-hidden">
              <div className="px-4 py-3 border-b font-semibold">Depósitos</div>
              <table className="min-w-full">
                <thead>
                  <tr className="bg-blue-100 text-left">
                    <th className="px-3 py-2">Nombre</th>
                    <th className="px-3 py-2">Alias</th>
                    <th className="px-3 py-2">Stock total</th>
                    <th className="px-3 py-2">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {depositos.map((deposito) => (
                    <tr key={deposito.id} className="border-t">
                      <td className="px-3 py-2 font-semibold">{deposito.nombre}</td>
                      <td className="px-3 py-2">{deposito.alias || '-'}</td>
                      <td className="px-3 py-2">{deposito.stock_total || 0}</td>
                      <td className="px-3 py-2 space-x-2">
                        <button className="bg-yellow-500 text-white px-3 py-1 rounded" onClick={() => editarDeposito(deposito)}>
                          Editar
                        </button>
                        <button className="bg-red-600 text-white px-3 py-1 rounded" onClick={() => eliminarDeposito(deposito)}>
                          Eliminar
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="bg-white rounded shadow overflow-hidden">
              <div className="px-4 py-3 border-b font-semibold">Depósito asignado a usuarios técnicos/admins</div>
              <table className="min-w-full">
                <thead>
                  <tr className="bg-blue-100 text-left">
                    <th className="px-3 py-2">Usuario</th>
                    <th className="px-3 py-2">Rol</th>
                    <th className="px-3 py-2">Depósito</th>
                  </tr>
                </thead>
                <tbody>
                  {tecnicosDepositos.map((tec) => (
                    <tr key={tec.tecnico_id} className="border-t">
                      <td className="px-3 py-2 font-semibold">{tec.usuario}</td>
                      <td className="px-3 py-2 capitalize">{tec.rol || '-'}</td>
                      <td className="px-3 py-2">
                        {String(tec.rol || '').toLowerCase() === 'admin' ? (
                          <div className="grid md:grid-cols-2 gap-2">
                            {depositos.map((deposito) => {
                              const asignados = depositosAsignadosUsuario(tec);
                              return (
                                <label
                                  key={deposito.id}
                                  className="flex items-center gap-2 rounded border border-gray-200 px-3 py-2 text-sm"
                                >
                                  <input
                                    type="checkbox"
                                    checked={asignados.includes(Number(deposito.id))}
                                    onChange={() => alternarDepositoUsuario(tec, deposito.id)}
                                  />
                                  <span>{deposito.nombre}</span>
                                </label>
                              );
                            })}
                          </div>
                        ) : (
                          <select
                            className="border px-3 py-2 rounded w-full"
                            value={tec.deposito_id || ''}
                            onChange={(e) => asignarDepositoTecnico(tec.tecnico_id, e.target.value)}
                          >
                            <option value="">Sin depósito asignado</option>
                            {depositos.map((deposito) => (
                              <option key={deposito.id} value={deposito.id}>
                                {deposito.nombre}
                              </option>
                            ))}
                          </select>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="bg-white rounded shadow overflow-x-auto">
            <div className="px-4 py-3 border-b font-semibold">Stock por depósito</div>
            <table className="min-w-full">
              <thead>
                <tr className="bg-blue-100 text-left">
                  <th className="px-3 py-2">Componente</th>
                  <th className="px-3 py-2">Depósito</th>
                  <th className="px-3 py-2">Cantidad</th>
                </tr>
              </thead>
              <tbody>
                {stockDepositos.map((item) => (
                  <tr key={`${item.componente_id}-${item.deposito_id}`} className="border-t">
                    <td className="px-3 py-2">
                      <div className="font-semibold">{item.componente_nombre}</div>
                      <div className="text-xs text-gray-500">{item.codigo_unico}</div>
                    </td>
                    <td className="px-3 py-2">{item.deposito_nombre}</td>
                    <td className="px-3 py-2">{item.cantidad}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {modalTransferencia.abierto && modalTransferencia.componente && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center p-4"
          onClick={cerrarModalTransferencia}
        >
          <div
            className="w-full max-w-2xl bg-white rounded-xl shadow-2xl overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between px-5 py-4 bg-gradient-to-r from-indigo-600 to-blue-600 text-white">
              <div>
                <h3 className="text-lg font-bold">Mover stock entre depósitos</h3>
                <p className="text-sm opacity-90">
                  {modalTransferencia.componente.nombre} · Stock total {modalTransferencia.componente.cantidad}
                </p>
              </div>
              <button
                type="button"
                onClick={cerrarModalTransferencia}
                className="bg-white bg-opacity-20 hover:bg-opacity-30 px-3 py-1 rounded"
                title="Cerrar"
              >
                X
              </button>
            </div>

            <form onSubmit={transferirStock} className="p-5 space-y-4">
              <div className="grid md:grid-cols-2 gap-4">
                <label className="block">
                  <span className="block text-sm font-semibold text-gray-700 mb-1">Depósito origen</span>
                  <select
                    name="deposito_origen_id"
                    value={modalTransferencia.deposito_origen_id}
                    onChange={cambiarTransferencia}
                    className="w-full border px-3 py-2 rounded"
                    required
                  >
                    <option value="">Seleccionar origen</option>
                    {depositos.map((deposito) => (
                      <option key={deposito.id} value={deposito.id}>
                        {deposito.nombre}{deposito.alias ? ` · ${deposito.alias}` : ''}
                      </option>
                    ))}
                  </select>
                </label>

                <label className="block">
                  <span className="block text-sm font-semibold text-gray-700 mb-1">Depósito destino</span>
                  <select
                    name="deposito_destino_id"
                    value={modalTransferencia.deposito_destino_id}
                    onChange={cambiarTransferencia}
                    className="w-full border px-3 py-2 rounded"
                    required
                  >
                    <option value="">Seleccionar destino</option>
                    {depositos.map((deposito) => (
                      <option key={deposito.id} value={deposito.id}>
                        {deposito.nombre}{deposito.alias ? ` · ${deposito.alias}` : ''}
                      </option>
                    ))}
                  </select>
                </label>
              </div>

              <label className="block">
                <span className="block text-sm font-semibold text-gray-700 mb-1">Cantidad a mover</span>
                <input
                  type="number"
                  min="1"
                  name="cantidad"
                  value={modalTransferencia.cantidad}
                  onChange={cambiarTransferencia}
                  className="w-full border px-3 py-2 rounded"
                  required
                />
              </label>

              <label className="block">
                <span className="block text-sm font-semibold text-gray-700 mb-1">Motivo</span>
                <textarea
                  name="motivo"
                  value={modalTransferencia.motivo}
                  onChange={cambiarTransferencia}
                  className="w-full border px-3 py-2 rounded"
                  rows={3}
                />
              </label>

              <div className="flex justify-end gap-2 pt-2">
                <button
                  type="button"
                  onClick={cerrarModalTransferencia}
                  className="px-4 py-2 rounded border hover:bg-gray-50"
                  disabled={modalTransferencia.enviando}
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700 disabled:opacity-60"
                  disabled={modalTransferencia.enviando}
                >
                  {modalTransferencia.enviando ? 'Moviendo...' : 'Mover stock'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default GestionComponentes;
